"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var HomeCustomerSearch = function (_a) {
    var initValue = _a.initValue, onChangeSearch = _a.onChangeSearch, clearFlag = _a.clearFlag;
    var timeout = react_1.useRef(null);
    var inputRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (clearFlag === null)
            return;
        if (inputRef.current === null)
            return;
        inputRef.current.value = "";
    }, [clearFlag]);
    var keyUpHandler = function (e) {
        var value = e.currentTarget.value;
        if (timeout.current !== null)
            clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            onChangeSearch(value.trim());
        }, 500);
    };
    return (react_1.default.createElement("div", { className: "home-search flex flex-row" },
        react_1.default.createElement("div", { className: "home-search__value" },
            react_1.default.createElement("input", { ref: inputRef, type: "text", placeholder: "Search", name: "search-value", defaultValue: initValue, onKeyUp: keyUpHandler }))));
};
exports.default = HomeCustomerSearch;
